import React, { ReactNode } from 'react';

// Material UI
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

// Data
import { APP_TITLE } from '../../../../../_configuration';

// Components
import { Logo } from '../../../_core/_ui/general.components';
import { SingleFormWrapper } from '../../../_core/_ui/structure.components';
import { useCompanyLogo } from '../../../../lib/stores/company.store';

interface ISingleFormLayout {
  children: ReactNode;
  width?: string;
  maxWidth?: string;
}

const SingleFormLayout: React.FC<ISingleFormLayout> = ({ children, width = 'auto', maxWidth }) => {
  const logo = useCompanyLogo();

  return (
    <React.Fragment>
      <Container>
        <Grid container justifyContent="center">
          <Grid item>
            <Logo src={logo} alt={APP_TITLE} />
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item>
            <Paper>
              <SingleFormWrapper width={width} maxWidth={maxWidth}>
                {children}
              </SingleFormWrapper>
            </Paper>
          </Grid>
        </Grid>
        {/* Matches FullPageLayout's bottom spacer so the card isn't flush to the viewport bottom. */}
        <div style={{ height: 8 }} aria-hidden />
      </Container>
    </React.Fragment>
  );
};

export default SingleFormLayout;
